import React from 'react';
import IconButton from 'components/IconButton';
import MoreVerticalIcon from '@nokia-csf-uxr/ccfk-assets/MoreVerticalIcon';

const SELECTED_BUTTON_STYLE = {
  outline: 'none',
  backgroundColor: 'rgba(0, 0, 0, 0.12)',
  '& [dataParent="button"] *': {
    fill: 'rgba(0,0,0,.76)'
  }
};

export interface SelectableButtonProps extends React.ComponentPropsWithRef<'button'> {
  /** To override the content of the IconButton. Consider using the Icon components. */
  children?: React.ReactNode;
  /** If `true`, the button will be disabled. */
  disabled?: boolean;
  /** Display the button as selected. */
  selected?: boolean;
}

/** Variant of icon button component that supports selected button style.
 * Any other props than `children` will be provided to the root `button` element.
 */
const SelectableButton = React.forwardRef<HTMLElement, SelectableButtonProps>((props: SelectableButtonProps, ref) => {
  const {
    children,
    disabled,
    selected,
    ...buttonProps
  } = props;

  return (
    <IconButton
      disabled={disabled}
      ref={ref}
      style={selected ? SELECTED_BUTTON_STYLE : {}}
      {...buttonProps}
    >
      {!!children && children}
      {!children && <MoreVerticalIcon />}
    </IconButton>
  );
});

SelectableButton.displayName = 'SelectableButton';

SelectableButton.defaultProps = {
  children: null,
  disabled: false,
  selected: false
};

export default SelectableButton;
